import React, { useState, useEffect } from 'react';
import ToggleSwitch from './ToggleSwitch';
import { useUsers } from '../Commoncontext/UsersContext';

function ConsentSettings() {
  const [settings, setSettings] = useState({
    termsAccepted: false,
    receiveEmails: false,
    electronicMailOnly: false,
    meetingNotificationsOnly: false,
  });
  const { user } = useUsers();

  const handleChange = (name) => (value) => {
    setSettings(prev => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    if (user) {
      setSettings({
        termsAccepted: user.suostumus || false,
      });
    }
  }, [user]);

  return (
    <div style={{ padding: '0px', background: '#333333', color: 'white' }}>
      <ToggleSwitch 
        label={<span style={{ marginRight: '15px' }}>Hyväksyn portaalin käyttöehdot ja<br/>tietosuojaselosteen</span>}
        checked={settings.termsAccepted}
        onChange={handleChange('termsAccepted')}
      />
      <ToggleSwitch 
        label={<span style={{ marginRight: '15px' }}>Haluan <strong>talonyhtiöportaalin<br/>viestit sähköpostiini</strong><br/></span>}
        checked={settings.receiveEmails}
        onChange={handleChange('receiveEmails')}
        disabled={true} // Toggle switch disabled
      />
      <ToggleSwitch 
        label={<span style={{ marginRight: '15px' }}>Haluan <strong>kirjepostit pelkästään</strong><br/><strong> sähköisesti</strong> talonyhtiöportaaliin<br/></span>}
        checked={settings.electronicMailOnly}
        onChange={handleChange('electronicMailOnly')}
        disabled={true} // Toggle switch disabled
      />
      <ToggleSwitch 
        label={<span style={{ marginRight: '15px' }}>Haluan <strong>yhtiökokouskutsut</strong><br/><strong>vain sähköisesti</strong></span>}
        checked={settings.meetingNotificationsOnly}
        onChange={handleChange('meetingNotificationsOnly')}
        disabled={true} // Toggle switch disabled
      />
    </div>
  );
}

export default ConsentSettings;
